
















import Vue from "vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";

export default Vue.extend({
    components: {
        iwInputCheckboxGroup: iwInputCheckboxGroup,
    },
    data: function () {
        return {
            smallPetpathInStore: "transaction.rental.residential.areSmallPetsAllowed",
            bigPetpathInStore: "transaction.rental.residential.areBigPetsAllowed",
            checkboxes: [
                {
                    value: "areSmallPetsAllowed",
                    label: "small_pets_allowed"
                },
                {
                    value: "areBigPetsAllowed",
                    label: "big_pets_allowed"
                },
            ]
        };
    },
    computed: {
        errorMessage: function(): string {
            const smallPetError = this.getErrorMessage(this.smallPetpathInStore);
            const bigPetError = this.getErrorMessage(this.bigPetpathInStore);

            let error = "";

            if (smallPetError) {
                error += smallPetError;
            }

            if (smallPetError && bigPetError) {
                error += ", ";
            }

            if (bigPetError) {
                error += bigPetError;
            }

            return error;
        },
        valueChecked: function(): Array<string> | void {
            let values = [];

            if (this.$store.getters["FormModule/getValue"](this.smallPetpathInStore)) {
                values.push("areSmallPetsAllowed");
            }

            if (this.$store.getters["FormModule/getValue"](this.bigPetpathInStore)) {
                values.push("areBigPetsAllowed");
            }

            return values;
        },
        isDisplayed: function(): boolean {
            return ["FOR_RENT"].indexOf(this.getTransactionType()) != -1;
        }
    },
    methods: {
        updateValue: function(selectedValues: Array<string>): void {

            if (selectedValues.indexOf("areSmallPetsAllowed") > -1) {
                this.$store.dispatch("FormModule/addValue", {path: this.smallPetpathInStore, value: true});
            } else {
                this.$store.commit("FormModule/deleteValue", this.smallPetpathInStore);
            }

            if (selectedValues.indexOf("areBigPetsAllowed") > -1) {
                this.$store.dispatch("FormModule/addValue", {path: this.bigPetpathInStore, value: true});
            } else {
                this.$store.commit("FormModule/deleteValue", this.bigPetpathInStore);
            }
        }
    }
});

